// extracted by mini-css-extract-plugin
export var feedback = "style-module--feedback--pkLK+";
export var heading = "style-module--heading--Qpq+j";
export var imglyTypoButton = "style-module--imgly--typo-button--TzU9B";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--qIcCl";
export var imglyTypoH1 = "style-module--imgly--typo-h1--Q-OJF";
export var imglyTypoH2 = "style-module--imgly--typo-h2--5noLf";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--aMKz6";
export var imglyTypoH3 = "style-module--imgly--typo-h3--IU-Dv";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--v-Fgn";
export var imglyTypoH4 = "style-module--imgly--typo-h4--gKVSj";
export var imglyTypoH5 = "style-module--imgly--typo-h5--6RoMg";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--xu7le";
export var imglyTypoIcon = "style-module--imgly--typo-icon--ssQBP";
export var imglyTypoLink = "style-module--imgly--typo-link--epvFu";
export var imglyTypoOverline = "style-module--imgly--typo-overline--fiuVO";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--hVD2x";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--9WQ+k";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--VZNuN";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--myRJ5";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--pfoPq";
export var imglyTypoSubline = "style-module--imgly--typo-subline--RKc3u";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--4JFS+";
export var naviLabelIsLarge = "style-module--navi-label-is-large--x8bQn";
export var naviLabelIsSmall = "style-module--navi-label-is-small--OFZgm";
export var root = "style-module--root--Noxvw";